import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../../../LoadingIndicator';
import { useDeviationViewContext } from '../../../Context';
import s from './DeviationPageLoader.scss';
export var DeviationPageLoader = function () {
    var isFullscreen = useDeviationViewContext().isFullscreen;
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']) },
        React.createElement(LoadingIndicator, { view: "llama", className: s['lloader'] })));
};
DeviationPageLoader.displayName = 'DeviationPageLoader';
export default DeviationPageLoader;
//# sourceMappingURL=DeviationPageLoader.js.map